import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VendorRequest } from '../models/requests/vendor-request';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { VendorDto } from '../models/VendorDto';

@Injectable({
  providedIn: 'root'
})
export class VendorsService {

  constructor(private httpClient: HttpClient) { }
  getVendors(): Observable<ApiResponseObject<VendorDto[]>> {
    return this.httpClient.get<ApiResponseObject<VendorDto[]>>(`${environment.apiUrl}/Contractors`);
  }
  
  saveVendors(newVendorRequest: VendorRequest): Observable<ApiResponseObject<VendorDto>> {
   
    return this.httpClient.post<ApiResponseObject<VendorDto>>(`${environment.apiUrl}/Contractors`, newVendorRequest);
  }
  updateVendor(newVendorRequest: VendorDto): Observable<ApiResponseObject<VendorDto>> {
   var result =this.httpClient.put<ApiResponseObject<VendorDto>>(`${environment.apiUrl}/Contractors`, newVendorRequest);
    return result;
  }
}
